import { render, staticRenderFns } from "./ForumSingle.vue?vue&type=template&id=22896266&scoped=true&"
import script from "./ForumSingle.vue?vue&type=script&lang=js&"
export * from "./ForumSingle.vue?vue&type=script&lang=js&"
import style0 from "./ForumSingle.vue?vue&type=style&index=0&id=22896266&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22896266",
  null
  
)

component.options.__file = "ForumSingle.vue"
export default component.exports